import { render, staticRenderFns } from "./TemplateOne.vue?vue&type=template&id=0588d5ee&scoped=true&"
import script from "./TemplateOne.vue?vue&type=script&lang=js&"
export * from "./TemplateOne.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOne.vue?vue&type=style&index=0&id=0588d5ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588d5ee",
  null
  
)

export default component.exports